import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IInitialState } from "./types";
import { reducers } from "./reducers";
import { getWorkplacesThunk } from "./asyncthunk";

const initialState: IInitialState = {
  loading: false,
  error: null,
  workplacesList: [],
};

const AuthSlice = createSlice({
  name: "auth",
  initialState,
  reducers: reducers,
  extraReducers: (builder) => {
    builder.addCase(
      getWorkplacesThunk.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.workplacesList = action.payload;
      },
    );
  },
});

export const {} = AuthSlice.actions;
export const selectWorkplacesList = (state: any) => state.authReducer.workplacesList

export default AuthSlice.reducer;
